import { Box, Typography } from '@mui/material'
import { CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox } from '@mui/icons-material'

type Props = {
  selected: boolean
  indeterminate?: boolean
  label: string
  onChange: (selected: boolean) => void
}

function Icon(props: { selected: boolean; indeterminate?: boolean }) {
  const { indeterminate, selected } = props
  if (indeterminate) {
    return <IndeterminateCheckBox />
  }
  if (selected) {
    return <CheckBox />
  }
  return <CheckBoxOutlineBlank />
}

export default function CheckLabel(props: Props) {
  const { selected, indeterminate, label, onChange } = props

  return (
    <Box
      sx={{ display: 'flex', direction: 'row', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
      onClick={(e) => {
        e.stopPropagation()
        onChange(!selected)
      }}
    >
      <Icon selected={selected} indeterminate={indeterminate} />
      <Typography color="disabled">{label}</Typography>
    </Box>
  )
}
